import React from 'react';

const LiveblogIcon = ({width="17", height="17", color="#fff", stroke='#fff'}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 17 17">
              <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
                <circle cx="7.5" cy="7.5" r="4.342" fill={color} />
                <circle cx="7.5" cy="7.5" r="7.5" stroke={stroke} />
              </g>
            </svg>
);

export { LiveblogIcon };